module.exports = __webpack_public_path__ + "static/media/AddGoals.37219493.png";